export default __webpack_public_path__ + "static/media/blurredMountainSunRays.97a07312.jpg";